import React, { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import BasvuruIadeKuralListesi from "../../services/basvuruIadeKuralList";
import kuralaGoreIadeEventEkle from "../../services/kuralaGoreIadeEventEkle";
import { Input, Row, Col, Spin, Form, Select, Button, Tooltip as TooltipAnd } from 'antd';
import * as util from "../Helpers/Util";

const { Option } = Select;
const { TextArea } = Input;

const parsed = queryString.parse(history.location.search);

const formItemStyle = {
    marginLeft: 10
}
const formLayout = {
    labelCol: {
        span: 4
    },
    wrapperCol: {
        span: 8
    }
}
const BasvuruIadeEtForm = () => {

    const [spining, setSpining] = useState(true);
    const [form] = Form.useForm();
    const [basvuruIadeKuralList, setBasvuruIadeKuralList] = useState([]);

    const loadForm = async () => {
        setSpining(true);
        await BasvuruIadeKuralListesi(parsed.basvuruId).then(resp => {
            if (resp.data.success) {
                setBasvuruIadeKuralList(resp.data.result);
            } else {
                util.errorMessage(resp.data.message);
            }
        }).catch(ex => {
            util.errorMessage(String(ex.message));
        });
        setSpining(false);
    }
    useEffect(() => {
        loadForm();
    }, []);

    const onFinish = async (values) => {
        setSpining(true);

        if (util.isNullOrEmptyOrUndefined(values.basvuruIadeKuralIds)) {
            util.errorMessage("Başvuru İadesi İçin Seçim Yapılmadığından İşleme Devam Edilemez.");
            setSpining(false);
        } else if (util.isNullOrEmptyOrUndefined(values.description)) {
            util.errorMessage("Açıklama yazmadan işleme devam edilemez.");
            setSpining(false);
        }
        else {
            let data = {
                basvuruId: parsed.basvuruId,
                basvuruIadeKuralIds: values.basvuruIadeKuralIds,
                description: values.description
            }

            await kuralaGoreIadeEventEkle(data).then(resp => {
                setSpining(false);
                if (!resp.data.success) {
                    util.errorMessage(resp.data.message);
                } else {
                    util.successMessage(resp.data.message);
                    window.parent.parent.location.reload();
                }
            }).catch(ex => {
                setSpining(false);
                util.errorMessage(String(ex.message));
            });
        }
    }


    return (
        <Spin tip={"Veriler Yükleniyor"} spinning={spining}>
            <Form form={form}  {...formLayout} onFinish={onFinish}>
                <Form.Item label="İade Edilecek Müellif/Raportör Seçiniz" key={parsed.basvuruId} name="basvuruIadeKuralIds" style={formItemStyle} labelAlign="left">
                    <Select
                        mode="multiple"
                        showSearch
                        allowClear
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        {basvuruIadeKuralList && basvuruIadeKuralList.map(bt => <Option key={bt.objectId} value={bt.objectId}>{bt.iadeEdilenSurecSecimAdi}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Açıklama"
                    name="description"
                    style={formItemStyle}
                    labelAlign="left"
                    rules={[{ required: true, message: "Lüften Açıklama giriniz" }]}
                >
                    <TextArea />
                </Form.Item>

                <Row>
                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button type="primary" htmlType="submit">
                            Kaydet
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Spin>
    );
}

export default BasvuruIadeEtForm;